import React, { useEffect, useMemo, useState } from 'react'
import { Modal, Box, Typography, FormControl, InputLabel, Select, MenuItem, Button, Stack } from '@mui/material'
import axios from '../../../services/withAxios'

interface Props {
  aberto: boolean
  setAberto: React.Dispatch<React.SetStateAction<boolean>>
}

const meses = [
  { value: 1, label: 'Janeiro' },
  { value: 2, label: 'Fevereiro' },
  { value: 3, label: 'Março' },
  { value: 4, label: 'Abril' },
  { value: 5, label: 'Maio' },
  { value: 6, label: 'Junho' },
  { value: 7, label: 'Julho' },
  { value: 8, label: 'Agosto' },
  { value: 9, label: 'Setembro' },
  { value: 10, label: 'Outubro' },
  { value: 11, label: 'Novembro' },
  { value: 12, label: 'Dezembro' }
]

const NfesDialog: React.FC<Props> = ({ aberto, setAberto }) => {
  const now = new Date()
  const [mes, setMes] = useState<number | ''>(now.getMonth() + 1)
  const [ano, setAno] = useState<number | ''>(now.getFullYear())

  const anos = useMemo(() => {
    const current = new Date().getFullYear()
    const start = current - 2
    const arr: number[] = []
    for (let a = start; a <= current; a++) arr.push(a)
    return arr.reverse()
  }, [])

  const fechar = () => setAberto(false)

  useEffect(() => {
    if (aberto) {
      const data = new Date()
      setMes(data.getMonth())
      setAno(data.getFullYear())
    }
  }, [aberto])

  const baixarZip = async () => {
    if (!mes || !ano) return
    const response = await axios.get(`/venda/GetNotasFiscaisMes/${mes}/${ano}`,
      { responseType: 'blob', params: { avoidFeedbackMessage: true } })

    const blob = new Blob([response.data], { type: 'application/zip' })
    const url = window.URL.createObjectURL(blob)

    const contentDisposition = response.headers['content-disposition'] as string | undefined
    let fileName = `arquivos_xml_notas_${mes}_${ano}.zip`
    if (contentDisposition) {
      const match = contentDisposition.match(/filename\*=UTF-8''([^;\n]*)|filename="?([^";\n]*)"?/i)
      const picked = decodeURIComponent((match?.[1] || match?.[2] || '').trim())
      if (picked) fileName = picked
    }

    const downloadLink = document.createElement('a')
    downloadLink.href = url
    downloadLink.download = fileName
    document.body.appendChild(downloadLink)
    downloadLink.click()
    downloadLink.remove()
    window.URL.revokeObjectURL(url)

    fechar()
  }

  const disabled = !mes || !ano

  return (
    <Modal open={aberto} onClose={fechar}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 3,
          minWidth: 360,
          borderRadius: 1
        }}
      >
        <Typography variant="h6" mb={2}>Download xml das notas fiscais por mês</Typography>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mb={2}>
          <FormControl fullWidth size="small">
            <InputLabel id="mes-label">Mês</InputLabel>
            <Select labelId="mes-label" label="Mês" value={mes} onChange={(e) => setMes(e.target.value as number)}>
              {meses.map(m => (
                <MenuItem key={m.value} value={m.value}>{m.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth size="small">
            <InputLabel id="ano-label">Ano</InputLabel>
            <Select labelId="ano-label" label="Ano" value={ano} onChange={(e) => setAno(e.target.value as number)}>
              {anos.map(a => (
                <MenuItem key={a} value={a}>{a}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <Button variant="outlined" onClick={fechar}>Fechar</Button>
          <Button variant="contained" onClick={baixarZip} disabled={disabled}>Baixar ZIP</Button>
        </Stack>
      </Box>
    </Modal>
  )
}

export default NfesDialog


